/* TheStudiz – product page helpers: sticky Add to Cart bar (mobile).
   Dhyan: koi observer us element ko nahi dekhta jise yeh script khud badalti hai (infinite loop se bachne ke liye). */
(function () {
  function init(bar) {
    if (!bar || bar.dataset.ready) return;
    var id = bar.dataset.sectionId;
    var button = bar.querySelector('[data-sticky-submit]');
    var priceEl = document.getElementById('StickyATC-Price-' + id);
    if (!button) return;
    bar.dataset.ready = 'true';

    function getMain() { return document.getElementById('ProductSubmitButton-' + id); }

    function syncState() {
      var main = getMain();
      if (!main) return;
      var disabled = main.disabled || main.getAttribute('aria-disabled') === 'true';
      var labelEl = main.querySelector('span');
      var label = labelEl ? labelEl.textContent.trim() : '';
      if (button.disabled !== disabled) button.disabled = disabled;
      if (label && button.textContent.trim() !== label) button.textContent = label;
    }

    function syncPrice() {
      if (!priceEl) return;
      var src = document.querySelector('#price-' + id + ' .price-item--sale') ||
        document.querySelector('#price-' + id + ' .price-item--regular');
      if (!src) return;
      var txt = src.textContent.trim().replace(/\s+/g, ' ');
      if (txt && priceEl.textContent.trim() !== txt) priceEl.textContent = txt;
    }

    button.addEventListener('click', function () {
      var main = getMain();
      if (main && !button.disabled) main.click();
    });

    /* Sirf main button aur price box ko dekho (dono bar ke bahar hain), aur sirf tab likho jab value badli ho. */
    var main0 = getMain();
    if (main0) new MutationObserver(syncState).observe(main0, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'], childList: true, subtree: true, characterData: true });
    var priceBox = document.getElementById('price-' + id);
    if (priceBox) new MutationObserver(syncPrice).observe(priceBox, { childList: true, subtree: true, characterData: true });
    syncState();
    syncPrice();

    /* Bar tab dikhao jab main buy button screen se bahar ho (neeche scroll karne par). */
    function show(visible) {
      if (bar.hidden === !visible) return;
      bar.hidden = !visible;
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle('has-sticky-atc', visible);
    }
    var main = getMain();
    if ('IntersectionObserver' in window && main) {
      var target = main.closest('.product-form__buttons') || main;
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        show(!e.isIntersecting && e.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(target);
    }
  }

  function boot() {
    document.querySelectorAll('.product-sticky-atc').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
